import { FC } from 'react';
import { CardHeaderProps } from './types';
import { styleCardHeader } from './style';
import clsx from 'clsx';

const CardHeader: FC<CardHeaderProps> = (props) => {
  const {
    className,
    heading,
    headingClassName,
    subheading,
    subheadingClassName,
    icon,
    actions,
    dim,
    ...rest
  } = props;

  const cls = styleCardHeader(props);
  return (
    <div className={clsx(cls.main, className)} {...rest}>
      {icon && <span className={clsx(cls.icon)}>{icon}</span>}
      <div className={clsx(cls.inner)}>
        {heading && (
          <h2 className={clsx(cls.heading, headingClassName)}>{heading}</h2>
        )}
        {subheading && (
          <p className={clsx(cls.subheading, headingClassName)}>{subheading}</p>
        )}
      </div>
      {actions && <div className={clsx(cls.actions)}>{actions}</div>}
    </div>
  );
};

export default CardHeader;
